import axios, { type AxiosProgressEvent } from 'axios';

import { type Common } from './common.js';
import {
  type CreateParams,
  type FindAllOptions,
  type KnowledgeBaseFile,
} from './models/flow/knowledgeBaseFile.js';
import { type PaginatedQueryOptions, type PaginationResponse } from './models/pagination/index.js';

export class API {
  common: Common;
  baseEndpoint = '/knowledge-base-files';

  constructor(common: Common) {
    this.common = common;
  }

  async findAllPaginated(
    queryParams?: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<KnowledgeBaseFile>> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }

  async findOneById(knowledgeBaseFileId: string): Promise<KnowledgeBaseFile> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${knowledgeBaseFileId}`);
    return await this.common.getJSON(url);
  }

  async create(params: CreateParams): Promise<KnowledgeBaseFile> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, params);
  }

  async upload(args: {
    knowledgeBaseFileId: string;
    file: File;
    contentType: string;
    progressHandler: (event: AxiosProgressEvent) => void;
  }): Promise<number> {
    const { knowledgeBaseFileId, file, contentType, progressHandler } = args;
    const url = this.common.constructPath(`${this.baseEndpoint}/upload-url`);
    const { url: uploadUrl } = await this.common.postJSON(url, {
      knowledgeBaseFileId,
    });
    const res = await axios.put(uploadUrl, file, {
      onUploadProgress: progressHandler,
      headers: { 'Content-Type': contentType },
    });
    return res.status;
  }
}
